import { resumeLabel } from "@toema/shared-types";
import type { OrderingState } from "@toema/shared-types";

export function isPaused(ordering: OrderingState | null): boolean {
  return ordering?.accepting === false;
}

export function reopensLabel(ordering: OrderingState, timezone: string | null, now: Date = new Date()): string {
  return ordering.pausedUntil && timezone ? resumeLabel(ordering.pausedUntil, timezone, now) : "";
}
